// extracted by mini-css-extract-plugin
export default {"table":"InnerTable_table__T1MgX"};